import React, { FC } from 'react';
import { Box, Text, TextFieldSize, TextField } from '@bechtel/gds';
import { useField } from 'formik';
import { useLingui } from '@lingui/react';
import { roundedHoursValue } from '~/detail/utils';
import { Scalars } from '@bechtel/types';

interface HoursInputProps {
  name: string;
  placeholder?: string;
  isDisabled?: boolean;
  roundingIncrement: Scalars['Float'];
}
export const HoursInput: FC<HoursInputProps> = ({ name, placeholder, isDisabled, roundingIncrement }) => {
  const [field, meta, helpers] = useField(name);
  const { setValue, setTouched } = helpers;
  return (
    <Box flexDirection={{ sm: 'column' }} m={{ sm: '500' }}>
      <TextField
        {...field}
        disabled={isDisabled}
        value={field.value ? field.value : ''}
        placeholder={placeholder}
        size={TextFieldSize.LARGE}
        maxLength={5}
        autoComplete="off"
        onKeyPress={(event) => {
          if (!/^[0-9]*\.?[0-9]*$/.test(event.key)) {
            event.preventDefault();
          }
        }}
        onChange={(e) => {
          setTouched(true);
          if (e.target.value.trim() == '.') {
            return;
          }
          const inputHours = e.target.value;
          const roundedHours = roundedHoursValue(inputHours, roundingIncrement);
          setValue(roundedHours);
        }}
      />
      {meta.touched && meta.error ? <ErrorField error={meta.error} /> : null}
    </Box>
  );
};
const ErrorField = ({ error }) => {
  const { i18n } = useLingui();
  return (
    <Box pt={{ sm: '200' }}>
      <Text color="bechtel.red">{i18n._(error)}</Text>
    </Box>
  );
};
